import { render } from "./CorrectedSquircle.vue?vue&type=template&id=0986b72e&scoped=true"
import script from "./CorrectedSquircle.vue?vue&type=script&lang=js"
export * from "./CorrectedSquircle.vue?vue&type=script&lang=js"

import "./CorrectedSquircle.vue?vue&type=style&index=0&id=0986b72e&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0986b72e"]])

export default __exports__